import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/forgot-password/page.tsx");
